export default {
    modal: {
        header: {
            text: "Statements",
        },
        popUpBlockerTitle: "Trouble opening your statement?",
        popUpBlockerDescription: "Please review your browser settings to ensure pop-ups aren't blocked.",
        paperLanguage: {
            A: {
                text: "Currently, you're enrolled in Paper Statements which includes a <strong> $1.99 monthly Paper Statement Fee. </strong> We will charge this fee in any billing cycle in which your balance is greater than $2.50 and you are sent a monthly billing statement in paper form (even if one is also provided to you in electronic form). You can avoid this fee if you set up Paperless Statements and are sent your statements only in electronic form. \n \n By choosing Paperless Statements, you confirm your <consentLink> Consent to Electronic Communications. </consentLink> You will receive an email notifying you when your Paperless Statement is available online. You will no longer receive a paper statement.",
            },
            B: {
                text: "If you select Paper Statements, you will receive paper statements through the U.S. mail in the future.  You will continue to have access to your Paperless Statements online and be notified by email when they are ready to view. \n \n A <strong> $1.99 monthly Paper Statement Fee </strong> will be charged to your account. We will charge this fee in any billing cycle in which your balance is greater than $2.50 and you are sent a monthly billing statement in paper form (even if one is also provided to you in electronic form). You can avoid this fee if you set up Paperless Statements and are sent your statements only in electronic form.",
            },
            C: {
                text: "Are you sure you want to turn Paperless Statements off? You will begin receiving paper statements through the U.S. mail in the future. You will no longer have access to past paperless statements online and will not be notified by email. \n \n A <strong> $1.99 monthly Paper Statement Fee </strong> will be charged to your account. We will charge this fee in any billing cycle in which your balance is greater than $2.50 and you are sent a monthly billing statement in paper form (even if one is also provided to you in electronic form). You can avoid this fee if you set up Paperless Statements and are sent your statements only in electronic form.​",
            },
            D: {
                text: "If you select Paper Statements, you will receive paper statements through the U.S. mail in the future. You will continue to have access to your Paperless Statements online and will be notified by email when they are ready to view.",
            },
            E: {
                text: "By choosing Paperless Statements, you confirm your <consentLink> Consent to Electronic Communications. </consentLink> You will receive an email notifying you when your Paperless Statement is available online. You can review your Paperless Statements by logging into the service site and clicking on the 'Statements' link. You will no longer receive a paper statement.",
            },
            F: {
                text: "Are you sure you want to turn Paperless Statements off? You will begin receiving paper statements in the mail and you will no longer have access to past statements online.",
            },
        },
        enroll: {
            title: "Enroll in Paperless Statements",
            consent: "By selecting “Go Paperless”, you agree to these terms to <consentLink>Consent to Electronic Communications </consentLink> for your account.",
            button: "GO PAPERLESS",
            error: {
                title: "Enrollment is currently unavailable.",
                description: "Please check back later to change your enrollment.",
            },
            delinquent: "Due to the status of your account, enrollment in paperless statements is currently unavailable.",
            error24Hour: "You must wait 24 hours before trying to enroll in Paperless Statements again.",
        },
        alreadyEnrolled: {
            title: "You are enrolled in paperless statements",
            body: "You will receive an email when new paperless statements are available to view and download. Only future monthly statements will be available electronically.",
            email: "Email Address:",
            editEmail: "Edit Email",
            link: "Turn off paperless statements",
            paperStatements: "Receive Paper Statements",
        },
        bothEnrolled: {
            title: "You are enrolled in paperless statements & paper statements",
            turnOffPaper: "Turn off paper statements",
        },
        paperStatements: {
            title: "Receive paper statements",
            firstParagraph: "Are you sure you want to receive paper statements? You will begin receiving paper statements in the mail in addition to the paperless statements online. ",
            secondParagraph: "Paper Statements may include a <strong> $1.99 monthly Paper Statement Fee. </strong> Check your account terms, including notifications of changes, to see if this fee applies to your account. We may charge this fee in any billing cycle in which your balance is greater than $2.50 and you are sent a monthly billing statement in paper form (even if one is also provided to you in electronic form). If applicable, you can avoid this fee if you set up paperless statements and are sent your statements only in electronic form.",
            mailPaper: "Yes, Mail paper statements",
            stayPaperless: "No, Stay paperless",
        },
        footer: {
            closeButton: "Close",
        },
        table: {
            balance: "Statement Balance",
            caption: "Missing statements may be due to a lack of activity or changes in your Paperless Statement enrollment status.",
            date: "Statement Date",
            privacy: "Privacy Policy",
            statement: "Statement",
            insert: "Insert",
            changeOfTerms: "Includes a change in terms. Open document to review.",
            tokenError: "This statement is currently unavailable.",
            insertError: "This insert is currently unavailable.",
        },
        noStatements: {
            title: "No Statements Available",
            notAvailable: "You are currently receiving paper statements by mail.",
            notRecent: "When available, you can view and download PDF statements from this page.",
        },
        statementsDown: {
            title: "Statements are unavailable",
            description: "Please try again later.",
        },
        unenrollPaperConfirm: {
            title: "Turn paper off",
            description: "Are you sure you want to turn paper statements off? You will no longer receive paper statements in the mail and you will continue to have access to paperless statements online.",
            buttonLeavePaper: "Leave paper on",
            buttonTurnPaperOff: "Turn paper off",
        },
        unenrollConfirm: {
            title: "Turn Paperless Statements off",
            buttonLeavePaperless: "LEAVE PAPERLESS STATEMENTS ON",
            buttonDoNotLeavePaperless: "TURN PAPERLESS STATEMENTS OFF",
        },
    },
    drawerHeader: {
        title: "SetPay Account",
        subtitle: {
            account: "Account ending in {{accountLast4}}",
            loan: "Loan ending in {{accountLast4}}",
        },
    },
    error: {
        api: {
            title: "Account Details Unavailable",
        },
        default: {
            title: "Sorry, there was an unexpected problem!",
            subtitle: "We're having trouble retrieving this information. Please reload the page or try again later.",
        },
        uiComponent: "Unavailable",
        littleTrouble: "Sorry, we're having a little trouble getting this information.",
        pleaseReload: "Please reload the page or try again later. If the problem continues, ",
        pageNotFound: "The page you’re looking for either doesn’t exist or can’t be found.",
        sorryPage: "Sorry, we couldn't find that page.",
        weApologize: "We Apologize",
        technicalDifficulties: "We are currently experiencing technical difficulties and are unable to access your account.",
        unableToFindAccount: "While your login was successful, we are unable to find the account associated with your credentials.",
        tryAgain: "Try Again",
        tryAgainLater: "Please try again later, or contact customer service for assistance.",
        accountClosedOrBlocked: "This account may have been closed or blocked.",
        contactCustomerService: "Please contact customer service at the number on the back of your card.",
    },
    footer: {
        body: "Your credit accounts are issued by Synchrony Bank.  The Synchrony Bank Privacy Policy governs the use of your credit accounts.  The use of this site is governed by the use of the Synchrony Bank Online Privacy Policy. The content and documents displayed may not all be provided in Spanish.",
        privacyPolicy: "Online Privacy Policy",
        privacyPolicyLink: "privacy-policy.html",
        usageAgreement: "Online Usage Agreement",
        usageAgreementLink: "terms-of-use.html ",
        fraudProtection: "Fraud Protection",
        fraudProtectionlink: "fraud-protection.html",
        accessibility: "Accessibility",
        accessibilityLink: "gwas",
    },
    button: {
        accountManager: "ACCOUNT MANAGER",
        alertsTooltip: "Manage enrollment in Alerts",
        clickHere: "click here",
        makeAPayment: "Make a Payment",
        paymentOptions: "View Payment Options",
        paymentPlan: "View Payment Plan",
        reload: "reload",
        signOut: "Sign Out",
        activity: "ACTIVITY",
        back: "BACK",
        goBackHome: "Go Back Home",
        languageText: "Español",
        close: "close",
        agreeAndContinue: "AGREE & CONTINUE",
        welcomeConfirmation: "GOT IT!",
        registerAccount: "REGISTER ACCOUNT",
        viewMyAccount: "View My Account",
        statements: "STATEMENTS",
        rewards: "REWARDS",
        accountDetails: "DETAILS",
        viewAllActivity: "View All Activity",
        activateCard: "Activate Card",
        profileToolTip: "Manage profile or sign out",
        profileManagement: "Profile Management",
    },
    logout: {
        pageTitle: "Logged Out",
        cardTitle: "Thank you for managing your Synchrony accounts.",
        cardDescription: "You've securely logged out.",
        button: "LOG BACK IN",
    },
    login: {
        loginText: "Login",
    },
    labels: {
        accountEndingIn: "Account ending in",
        loanEndingIn: "Loan ending in",
        dueDate: "Payment Due Date",
        monthlyPaymentAmount: "Monthly Payment Amount",
        totalMinimumPayment: "Total Minimum Payment",
        noPaymentDue: "No Payment Due",
        forHelp: "for help.",
        creditLimit: "Credit Limit",
        currentBalance: "Current Balance",
        totalPaid: "Total Paid",
        availableToSpend: "Available to spend",
        accountSnapshot: "ACCOUNT SNAPSHOT",
        totalRemaining: "Total Remaining",
        monthlyPayment: "Monthly Payment",
        currentBalanceTooltip: "May not reflect recent transactions.",
        unavailable: "Unavailable",
        recentActivity: "Recent Activity",
        currentBalanceAlt: "Current Balance Information",
    },
};
